import { parseMessage } from './parseMessage';
import { isErrorMessage } from './DataMessage';

export const errorEventListener = (message: Uint8Array) => {
    const parsedMessage = parseMessage(message);
    if (parsedMessage && isErrorMessage(parsedMessage)) {
        console.error('Voice Agent error: ', parsedMessage);
    }
};
